import {createSelector} from 'reselect';

export const selectPurchaseAutoPurchase = state => state.getIn(['purchase', 'autoPurchase']);
export const selectPurchaseOffers = state => state.getIn(['purchase', 'offers']);
export const selectPurchaseInProgress = state => state.getIn(['purchase', 'purchaseInProgress']);
export const selectUserDidClickPurchase = state =>
    state.getIn(['purchase', 'userDidClickPurchase']);
export const selectUserDismissedCompatibiltyWarning = state =>
    state.getIn(['purchase', 'userDismissedCompatibiltyWarning']);
export const selectUsersPlatformIsFullySupported = state =>
    state.getIn(['purchase', 'usersPlatformIsFullySupported']);

export const selectPurchaseOfferById = createSelector(
    (_, props) => props.offerId || props.id,
    selectPurchaseOffers,
    (offerId, offers) => offers.get(offerId)
);

export const selectUserDidClickPurchaseByProductName = createSelector(
    (_, props) => props.productName,
    selectUserDidClickPurchase,
    (productName, userDidClickPurchase) => userDidClickPurchase.get(productName)
);

export const selectUserDismissedCompatibilityWarningByProductName = createSelector(
    (_, props) => props.productName,
    selectUserDismissedCompatibiltyWarning,
    (productName, userDismissedCompatibilityWarning) =>
        userDismissedCompatibilityWarning.get(productName)
);

export const selectUsersPlatformIsFullySupportedByProductName = createSelector(
    (_, props) => props.productName,
    selectUsersPlatformIsFullySupported,
    (productName, usersPlatformIsFullySupported) => usersPlatformIsFullySupported.get(productName)
);

export const selectIsPurchaseDisabledById = createSelector(
    selectPurchaseInProgress,
    selectPurchaseOfferById,
    (purchaseInProgress, purchaseOffer) => {
        if (purchaseInProgress) return true;

        // this offer id is explicitly marked as disabled/succeeded from purchase (and is likely waiting to fetch new ownership data)
        return (
            purchaseOffer &&
            (purchaseOffer.get('purchaseButtonDisabled') || // button explicitly disabled
                // button not in-progress, but we finished a purchase and may not have all the info to flip to owned state yet
                purchaseOffer.get('purchaseSuccess'))
        );
    }
);
